module.exports = __webpack_public_path__ + "static/media/finances.d92cb8b3.jpg";